import clienteAxios from '../config/axios';

/*
====================================
SOLICITAR PDF DE ANAMNESIS
====================================

El frontend solamente envía el UUID
del paciente seleccionado.

El backend obtiene los nombres reales
del paciente y del profesional desde
la base de datos.

No necesitamos almacenar el PDF en Redux.
====================================
*/

export const solicitarAnamnesisPdf = async ({
    config,
    id_paciente
}) => {

    if (!id_paciente) {
        throw new Error(
            'Falta seleccionar un paciente.'
        );
    }

    const respuesta = await clienteAxios.post(
        '/paciente/generaranamnesispdf',
        {
            id_paciente
        },
        {
            ...config,
            responseType: 'blob'
        }
    );

    return respuesta.data;
};